import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AccessDeniedImg from 'assets/images/access_denied.webp';
import useCurrentUser from 'hooks/useCurrentUser';
import useQuery from 'hooks/useQuery';
import { useNavigate } from 'react-router-dom';
import { useAssignClientByTokenQuery } from 'services/api/user.api';

const AssignClient = () => {
  const query = useQuery();
  const clientId = query.get('clientId');
  const token = query.get('token');
  const navigate = useNavigate();
  const currentUser = useCurrentUser();

  if (!clientId || !token) {
    return (
      <div>
        <p>Client ID or token not found</p>
      </div>
    );
  }
  if (currentUser && !currentUser.isAssignable) {
    navigate(`/clients/${clientId}`);
    return null;
  }
  const { data, error } = useAssignClientByTokenQuery({
    clientId: Number(clientId),
    token: String(token),
  });
  if (error) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          pt: 10,
        }}
      >
        <img src={AccessDeniedImg} alt="error" width="500" />
        <Typography variant="h4">
          El link al que estás tratando de acceder no es válido.
          {'data' in error &&
            typeof error.data === 'string' &&
            error.data.includes('has another user assigned') &&
            ' Otro ejecutivo ya se ha asignado el cliente.'}
        </Typography>
      </Box>
    );
  }
  if (data) {
    navigate(`/clients/${clientId}`);
  }
  return null;
};

export default AssignClient;
